import { DummyStore } from 'stores';

export const organizerCurrenciesIds = new DummyStore<number[]>();
export const organizerStore = new DummyStore<any>();
